import { render, staticRenderFns } from "./ProfileColaborador.vue?vue&type=template&id=b9ff66f6&scoped=true"
import script from "./ProfileColaborador.vue?vue&type=script&lang=js"
export * from "./ProfileColaborador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ff66f6",
  null
  
)

export default component.exports